import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/casos-de-exito/gmp-support-for-closing-capas-across-qa-qualval-and-software")({
  head: () => buildRouteHead("/es/casos-de-exito/gmp-support-for-closing-capas-across-qa-qualval-and-software", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/casos-de-exito/soporte-gmp-para-el-cierre-de-capa-en-garantia-de-calidad-cualificacion-y-validacion-y-software", replace: true });
  },
});
